// nosemgrep: typescript.factorial-frontend.design-system-outside-dependencies
import { NavigationElement } from 'modules/core/lib/navigation/types'

import { ResolvedHandleData } from './useResolvedHandles'

export const getTabs = (
  handleData: ResolvedHandleData[],
  resourceIndex?: number | undefined
): NavigationElement[][] => {
  const handlesAfterResource =
    resourceIndex && resourceIndex >= 0 ? handleData.slice(resourceIndex) : handleData

  const tabs: NavigationElement[][] = handlesAfterResource
    .filter(subNavigationExists)
    .map(({ meta }) => {
      const subNavigation = meta?.subNavigation?.filter(Boolean) ?? []
      return subNavigation.filter((item) => ('isVisible' in item ? Boolean(item.isVisible) : true))
    })

  const firstEmptyLevel = tabs.findIndex((level) => level.length === 0)

  // if the tab level is empty, it containes no visible elements
  // all lower levels must not be reachable
  return firstEmptyLevel !== -1 ? tabs.slice(0, firstEmptyLevel) : tabs
}

const subNavigationExists = (handle: ResolvedHandleData) => {
  return handle?.meta?.subNavigation && handle.meta.subNavigation.length > 0
}
